// See docs/loadable-components.md for details regarding **.imports-X.** file extension & duplicate file structure.
import loadable from '@loadable/component';
import retry from '../../../../utils/retry';

const SelectedItemForm = loadable(() => retry(() => import('./ModernSelectedItemForm')));

export default SelectedItemForm;
